module.exports = __webpack_public_path__ + "static/img/about1.957f9412.jpg";